<script setup lang="ts">
import { ref } from 'vue'
import { RouterView, useRouter } from 'vue-router'
import SiteFooter from '@/components/common/SiteFooter.vue'
import SiteHeader from '@/components/common/SiteHeader.vue'

const router = useRouter()

const main = ref<HTMLElement | null>(null)
router.afterEach(() => {
  if (main.value) {
    main.value.classList.remove('is-loaded')
    void main.value.offsetWidth

    setTimeout(() => {
      if (main.value) {
        main.value.classList.add('is-loaded')
      }
    }, 100)
  }
})
</script>

<template>
  <div class="contents">
    <SiteHeader />
    <main class="main" ref="main">
      <div class="inner">
        <RouterView />
      </div>
      <div class="bottom-bg">
        <img
          src="@/assets/images/webp/common/bottom_bg.webp"
          alt=""
          width="828"
          height="837"
          type="image/webp"
        />
      </div>
    </main>
    <SiteFooter />
  </div>
</template>

<style lang="scss">
@use '@/assets/scss/inc/_function' as *;
@use '@/assets/scss/inc/_mixin' as *;

.contents {
  @include media(lg) {
    max-width: var(--content-width);
    margin-inline: auto;
  }
}

.main {
  opacity: 0;
  transition: none;

  &.is-loaded {
    transition: opacity 0.5s var(--ease);
    opacity: 1;
  }
}

.main {
  padding-block: var(--header-height) 8rem;
  min-height: calc(100svh - var(--footer-height));
  position: relative;

  .bottom-bg {
    position: absolute;
    bottom: -4rem;
    z-index: -1;
  }
}
</style>
